import { Label } from "@sanity/ui";
import styled from "styled-components";

const SectionLabel = styled(Label)`
  border-bottom: 1px solid currentColor;
  margin-top: 1em;
`;

export default SectionLabel;
